import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from '../components/button/v2/button';
import { HButtonGroup } from '../components/button/v2/HButtonGroup';
import BannerContainer from '../components/containers/banner.container';
import Container from '../components/containers/container';
import FeedsContainer from '../components/containers/feeds.container';
import Header from '../components/header/default.header';
import Icon from '../components/icons/icon';
import { HStack, VStack } from '../components/layouts/stack.layout';
import MainLayout from '../components/layouts/v2/main.layout';
import AlternativeNavigation from '../components/navigation/alternative.navigation';
import HTab from '../components/navigation/tabs/htab';
import { PROFILE_TAB_OPTIONS } from '../components/navigation/tabs/tab-options';
import Heading from '../components/typography/v2/heading';
import Text from '../components/typography/v2/text';
import ExternalLinkWrapper from '../components/utility/external-link-wrapper';
import { MARKETPLACE_URL } from '../constants';
import { me, userProfileData } from '../test.data';

// this needs a clean up
// 1. breakdown banner component
// 2. reduce prop drilling

// this could be a class

export default function Profile() {
  const [currentValue, setCurrentValue] = useState(PROFILE_TAB_OPTIONS.DETAILS);

  const params = useParams();

  const profileId = params.profileId;

  const CONTENT_COMPONENT_MAP = {
    [PROFILE_TAB_OPTIONS.FEEDS]: () => (
      <FeedsContainer
        query={['SOCIAL_FEEDS', 'HOLDR_FEEDS']}
        params={{ id: profileId || '' }}
      />
    ),
    [PROFILE_TAB_OPTIONS.ARTICLES]: () => (
      <FeedsContainer query={['NEWS_FEEDS']} params={{ id: profileId || '' }} />
    ),
    [PROFILE_TAB_OPTIONS.DETAILS]: () => (
      <div className="mobile:px-2 tablet-lg:px-[40px]">Details</div>
    ),
    [PROFILE_TAB_OPTIONS.COLLECTIONS]: () => (
      <div className="mobile:px-2 tablet-lg:px-[40px]">Collections</div>
    ),
  };

  const user = userProfileData.find(
    (profile) => profile.username === profileId
  );

  useEffect(() => {
    document.title = `The Base | ${me.username}`;
  }, []);

  return (
    <MainLayout>
      <MainLayout.Header>
        <Header />
      </MainLayout.Header>
      <MainLayout.Content>
        <MainLayout.Navigation>
          <AlternativeNavigation />
        </MainLayout.Navigation>
        <MainLayout.Banner>
          {user && (
            <>
              <BannerContainer
                variant={user.username === me.username ? 'owned' : 'artist'}
                username={user.username}
                bannerUrl={user.bannerUrl}
                avatarUrl={user.avatarUrl}
                displayName={user.displayName}
                trackers={user.trackers || '0'}
                tracking={`${me.tracking.length}`}
                sales={'2.71' || '0'}
                collections={user.collections || '0'}
              />
              <Container extensions="pt-[30px] px-2">
                <VStack
                  extensions="w-full mobile:px-0 tablet-sm:px-7 pb-3"
                  gap="sm"
                >
                  <HStack
                    wrap="wrap"
                    extensions="w-full items-center mobile:gap-3 tablet-lg:gap-0"
                    justify="between"
                  >
                    <HStack
                      extensions="items-center mobile:w-full tablet-sm:w-1/3"
                      gap="xs"
                    >
                      <Heading>{user.displayName}</Heading>
                      {user.verified && (
                        <Icon size="sm" icon="verified" color="quartiary" />
                      )}
                    </HStack>
                    <HStack extensions="w-full mobile:justify-between tablet-lg:gap-3 tablet-lg:justify-end tablet-lg:w-2/3">
                      <HButtonGroup>
                        <ExternalLinkWrapper
                          link={`${MARKETPLACE_URL}/${user.username}`}
                        >
                          <Button
                            color="glass"
                            asIcon="marketplace"
                            withButtonStyle
                          />
                        </ExternalLinkWrapper>
                        {user.spotifyLink && (
                          <ExternalLinkWrapper link={user.spotifyLink}>
                            <Button
                              color="glass"
                              asIcon="spotify"
                              withButtonStyle
                            />
                          </ExternalLinkWrapper>
                        )}
                        {user.youtubeLink && (
                          <ExternalLinkWrapper link={user.youtubeLink}>
                            <Button
                              color="glass"
                              asIcon="youtube"
                              withButtonStyle
                            />
                          </ExternalLinkWrapper>
                        )}
                      </HButtonGroup>
                      {user.username !== me.username && (
                        <Button
                          size="sm"
                          color={'primary'}
                          variant={'outline'}
                          text={'track'}
                        />
                      )}
                    </HStack>
                  </HStack>
                  <Text>{'Bio coming soon'}</Text>
                </VStack>
              </Container>
            </>
          )}
        </MainLayout.Banner>
        <MainLayout.Main>
          <Container extensions="w-full h-full relative">
            <Container extensions="mobile:w-full">
              <Container extensions="w-full">
                <HTab
                  set={setCurrentValue}
                  current={currentValue}
                  tabOptions={PROFILE_TAB_OPTIONS}
                  tabContent={CONTENT_COMPONENT_MAP}
                  tabControlClassName="py-4 mobile:px-2 tablet-lg:px-[40px] border-y border-dark-gray"
                />
              </Container>
            </Container>
          </Container>
        </MainLayout.Main>
      </MainLayout.Content>
    </MainLayout>
  );
}
